export type Context = Record<string, unknown>;
export type Contexts = Record<string, Context>;
